import { BrowserRouter as Router } from "react-router-dom"
import { ToolProvider } from "../core/context/ToolContext"
import { WebRoute } from "../core/webrouter/Authentication"

export const Index = ({ platform }) => {
    return <ToolProvider platform="authentication"><Router><WebRoute platform="authentication" /></Router></ToolProvider>
}